import React from 'react';
import { StatCardWrapper, StatLabel, StatValue } from './index.style';

const StatCard = ({ value, label, isHighlight, renderButtonGift }) => (
  <StatCardWrapper>
    <div className="stat-card-content">
      <StatValue isHighlight={isHighlight}>{value}</StatValue>
      <StatLabel>{label}</StatLabel>
    </div>
    {renderButtonGift && renderButtonGift()}
  </StatCardWrapper>
);

export default StatCard;
